import { OfferPrintStatusDto } from '@/api/generated';

type StatusOptions = Record<OfferPrintStatusDto, string>;

const statusOptions: StatusOptions = {
  [OfferPrintStatusDto.Active]: 'Aktywny',
  [OfferPrintStatusDto.Inactive]: 'Nieaktywny',
};

export type OfferTemplatesTranslation = {
  button: {
    add: string;
  };
  createDialog: {
    button: {
      cancel: string;
      submit: string;
    };
    form: {
      file: string;
      fileSelected: string;
      name: string;
      pageNumber: string;
      status: string;
      statusOptions: StatusOptions;
    };
    hint: {
      pageNumber: string;
      pageOutOfRange: string;
      pdfError: string;
      totalPages: string;
      uploadFirst: string;
    };
    preview: {
      endTitle: string;
      startTitle: string;
    };
    title: string;
  };
  previewDialog: {
    button: {
      close: string;
    };
    endTitle: string;
    startTitle: string;
    title: string;
  };
  table: {
    button: {
      add: string;
    };
    filters: {
      fullTextSearchInput: string;
      status: string;
    };
    head: {
      createdAt: string;
      createdBy: string;
      name: string;
      pageNumber: string;
      status: string;
    };
    row: {
      actions: {
        preview: string;
        toggleStatus: string;
      };
      status: StatusOptions;
    };
  };
};

export const offerTemplatesTranslation: OfferTemplatesTranslation = {
  button: {
    add: 'Dodaj szablon',
  },
  createDialog: {
    button: {
      cancel: 'Anuluj',
      submit: 'Zapisz',
    },
    form: {
      file: 'Plik PDF',
      fileSelected: 'Wybrany plik: {{name}}',
      name: 'Nazwa szablonu',
      pageNumber: 'Numer strony (punkt podziału)',
      status: 'Status',
      statusOptions,
    },
    hint: {
      pageNumber:
        'Numer strony określa, po której stronie szablonu wstawiana jest dynamiczna zawartość oferty (np. 2 = strony 1–2 idą na początek, dalej oferta, potem reszta szablonu).',
      pageOutOfRange:
        'Numer strony jest większy niż liczba stron w pliku ({{total}}). Popraw wartość, aby zapisać.',
      pdfError: 'Nie udało się odczytać pliku PDF: {{error}}',
      totalPages: 'Liczba stron w pliku: {{count}}',
      uploadFirst: 'Wgraj plik PDF, aby zobaczyć podgląd.',
    },
    preview: {
      endTitle: 'Strony końcowe',
      startTitle: 'Strony początkowe (1–{{count}})',
    },
    title: 'Nowy szablon oferty',
  },
  previewDialog: {
    button: {
      close: 'Zamknij',
    },
    endTitle: 'Strony końcowe',
    startTitle: 'Strony początkowe (1–{{count}})',
    title: 'Podgląd szablonu: {{name}}',
  },
  table: {
    button: {
      add: 'Dodaj szablon',
    },
    filters: {
      fullTextSearchInput: 'Szukaj po nazwie',
      status: 'Status',
    },
    head: {
      createdAt: 'Data dodania',
      createdBy: 'Dodał(a)',
      name: 'Nazwa',
      pageNumber: 'Nr strony',
      status: 'Status',
    },
    row: {
      actions: {
        preview: 'Podgląd',
        toggleStatus: 'Aktywuj / Dezaktywuj',
      },
      status: statusOptions,
    },
  },
};
